import Button from "app/components/UI/Button";
import Chip from "app/components/UI/Chip";
import ClubList from "app/components/ClubList";
import Flex from "app/components/UI/Flex";
import ImmutablePropTypes from "react-immutable-proptypes";
import ModalChangeClub from "app/components/ModalChangeClub";
import PropTypes from "prop-types";
import React from "react";
import SearchInput from "app/components/UI/SearchInput";
import Spinner from "app/components/UI/Spinner";
import Title from "app/components/UI/Title";
import classes from "./HomePage.module.css";

export const HomePage = ({
  translate,
  translateHtml,
  clubs,
  isLoading,
  geolocAvailable,
  position,
  searchValue,
  onSearchValueChange,
  isOpen,
  onClose,
  onDeletePosition,
  onGeoloc,
  onChangeClub,
  onChangeClubConfirm,
  sale
}) => (
  <div className={classes.pageContainer}>
    <Title component="h2">{translate("Mon golf")}</Title>

    <div className={classes.homePageContainer}>
      <div className={classes.searchContainer}>
        <Flex direction="row" center middle className={classes.search__content}>
          {geolocAvailable ? (
            <Button.Icon className={classes.search__icon} onClick={onGeoloc}>
              gps_fixed
            </Button.Icon>
          ) : (
            ""
          )}
          {position ? (
            <Chip onRequestDelete={onDeletePosition} className={classes.search__position}>
              {translate("Ma position")}
            </Chip>
          ) : (
            <SearchInput
              className={classes.search__field}
              onChange={onSearchValueChange}
              value={searchValue}
              placeholder={translate("Rechercher par Nom, ville ou code postal")}
              block
            />
          )}
        </Flex>
      </div>
      <Title component="h2">
        {!searchValue && !position && clubs.size ? translate("Tous les clubs") : ""}

        {!clubs.size ? translate("Aucun club") : ""}

        {(searchValue || position) && clubs.size ? translate("Résultat ({num})", { num: clubs.size }) : ""}
      </Title>

      <div className={classes.resultContainer}>
        {isLoading ? (
          <Spinner absolute />
        ) : (
          <ClubList clubs={clubs} onChangeClub={onChangeClub} currentPosition={position} />
        )}
      </div>
    </div>

    {sale && (
      <ModalChangeClub
        open={isOpen}
        onRequestClose={onClose}
        saleClubId={sale.get("clubId")}
        onChangeClubConfirm={onChangeClubConfirm}
      >
        {translateHtml(
          "La club que vous souhaitez sélectionner ne peut être associée aux articles déjà présents dans votre panier : vous devez d'abord valider ou annuler votre panier en cours pour pouvoir le sélectionner."
        )}
      </ModalChangeClub>
    )}
  </div>
);

HomePage.propTypes = {
  translate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  clubs: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
  isOpen: PropTypes.bool.isRequired,
  geolocAvailable: PropTypes.bool.isRequired,
  position: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onGeoloc: PropTypes.func.isRequired,
  onDeletePosition: PropTypes.func.isRequired,
  onChangeClubConfirm: PropTypes.func.isRequired,
  onChangeClub: PropTypes.func.isRequired
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/app/components/HomePage/HomePage.js